import React from 'react';
import { CanopyTent } from './tents';
import * as special from './special';

/**
 * Booth dispatcher.
 *
 * Every "tent-style" exhibitor booth (khemah_pempamer, khemah_utama,
 * khemah_makan, small_booth, support tents, etc.) renders as a uniform
 * 20x20 ft `CanopyTent` so the venue reads as one consistent bazaar.
 *
 * A small whitelist of *special* structures keeps its own unique 3D
 * geometry so the map still communicates "this is a stage / food truck
 * / playground / garden plot / colourful MyKiosk".
 */

// Types that render with their own custom mesh (not a canopy tent).
export const SPECIAL_STRUCTURES = new Set([
  'pentas_utama',   // Main stage — trussing, LED wall, stage platform
  'food_truck',     // Wheeled truck with awning
  'supa_dupa',      // Inflatable kids playground
  'plot_pbt',       // Local authority garden plot (grass + plants)
  'my_kiosk',       // Small colourful kiosk stall
]);

export function StructureShape({ structureType, ...geom }) {
  switch (structureType) {
    case 'pentas_utama':  return <special.PentasUtama {...geom} />;
    case 'food_truck':    return <special.FoodTruck {...geom} />;
    case 'supa_dupa':     return <special.SupaDupa {...geom} />;
    case 'plot_pbt':      return <special.PlotPBT {...geom} />;
    case 'my_kiosk':      return <special.MyKiosk {...geom} />;
    default:              return <CanopyTent {...geom} />;
  }
}
